import type { AnalyticsMetadata, AnalyticsMetadataMapKeys } from "@/dto";
import { analyticsService } from "../services/analyticsService";

export interface DispatchAnalyticsOptions {
  addPlatformLocation?: boolean;
  trackEventInIntercom?: boolean;
}

function dispatchAnalytics<T extends AnalyticsMetadataMapKeys>(
  name: T,
  data?: AnalyticsMetadata<T> | null,
  options?: DispatchAnalyticsOptions
): void {
  const metadata = data ?? ({} as AnalyticsMetadata<T>);
  const addPlatformLocation = options?.addPlatformLocation ?? true;
  const trackEventInIntercom = options?.trackEventInIntercom ?? false;

  if (addPlatformLocation) {
    metadata.platformLocation = analyticsService.splitUrl({ transformNameForAnalytics: true });
  }

  analyticsService.track(name, metadata, { trackEventInIntercom });
}

const startSessionRecordingWithoutFeatureFlag = (): void => {
  window.posthog?.startSessionRecording?.();
};

export const useAnalyticsService = () => {
  return {
    dispatchAnalytics,
    startSessionRecordingWithoutFeatureFlag
  };
};
